import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupScriptsPlugin from '@swup/scripts-plugin';
// import Splide from '@splidejs/splide';
// import AOS from 'aos';
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import intersect from '@alpinejs/intersect'

import main from './alpine/main';
import options from './alpine/options';
import slider from './alpine/slider';
import drawer from './alpine/drawer';
import license from './alpine/license';
import licensePlatform from "./alpine/licensePlatform";
import typetester from './alpine/typetester';
import Trial from './trial';
import {checkoutSummary, checkoutSummaryActions} from "./alpine/checkoutSummary";
import checkoutFields from "./alpine/checkoutFields";



window.isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

const swupoptions = {
    plugins: [
        new SwupBodyClassPlugin(),
        new SwupScriptsPlugin({
            optin: true
        })
    ]
};

const swup = new Swup(swupoptions); 

// Events
swup.hooks.on("page:view", (visit) => {
    init();
});


Alpine.plugin(intersect)
Alpine.plugin(collapse)
Alpine.data('main', main);
Alpine.data('options', options);
Alpine.data('slider', slider);
Alpine.data('drawer', drawer);
Alpine.data('license', license);
Alpine.data('licensePlatform', licensePlatform);
Alpine.data('typetester', typetester);
Alpine.data('checkoutSummary', checkoutSummary);
Alpine.data('checkoutSummaryActions', checkoutSummaryActions)
Alpine.data('checkoutFields', checkoutFields)

window.Alpine = Alpine

Alpine.store('cart', {
    data: [],
    constants: {},
    replace(newData) {
        this.data = newData
    },
    setConstants(constants) {
        this.constants = constants
    },
    setPrices(prices) {
        this.prices = prices
    }
})
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
    l('ready');
    // checkCookie();
    init();
});

// Functions 
function l(m) {
    console.log(m);
}

let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
window.isMobile = isMobile;

function init() {
    l('👍');
    if(window.location.hash) {
        // let hash = window.location.hash.split('#')[1];   
        // if(document.getElementById(hash)) {
        //     // l('scroll to hash') 
        //     // let point = document.getElementById(hash).getBoundingClientRect().top;
        //     // l(point);
        //     // window.scrollTo(0, point);
        // }
    } else {
        l('start at top');
        window.scrollTo(0, 0);
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
    }
    trials();

    if(document.querySelector('.home_about a')) {
        document.querySelector('.home_about a').addEventListener('click', function(e) {
            if(e.target.hash == '#typefaces') {
                window.scrollTo(0, document.querySelector('#typefaces').offsetTop - 70, {
                    behavior: 'smooth'
                });
            } else {
                e.preventDefault();
            }
        });
    }
}

function trials() {
    for (const trialElem of document.querySelectorAll('[data-role="trial"]')) {
        const trial = new Trial();
        trial.mount(trialElem);
    }
}
